'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideoLibrary = function AvVideoLibrary(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
  );
};
AvVideoLibrary = (0, _pure2.default)(AvVideoLibrary);
AvVideoLibrary.displayName = 'AvVideoLibrary';
AvVideoLibrary.muiName = 'SvgIcon';

exports.default = AvVideoLibrary;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/video-library.js
// module id = 1177
// module chunks = 0